import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', href: '/' },
    { label: '功能指南', href: '/category/guide' },
    { label: '最新动态', href: '/category/news' },
    { label: '常见问题', href: '/category/faq' },
  ],
  关于平台: [
    { label: '关于我们', href: '/about' },
    { label: '品牌介绍', href: '/about#brand' },
    { label: '信誉展示', href: '/about#reputation' },
    { label: '联系方式', href: '/about#contact' },
  ],
  热门文章: [
    { label: '91.cc 官方入口指南', href: '/article/official-entry-guide' },
    { label: '新用户注册教程', href: '/article/registration-tutorial' },
    { label: '平台功能介绍', href: '/article/platform-features' },
    { label: '安全访问注意事项', href: '/article/security-tips' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200" role="contentinfo">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold font-heading text-background-50">
                91<span className="text-primary-400">.</span>cc
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              91.cc 官方平台入口与核心功能全解析，为用户提供全面的使用指南、最新动态和常见问题解答，助力用户安全便捷地访问 91.cc 平台。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="https://91.cc" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="访问 91.cc">
                <i className="ri-global-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 91.cc 信息导航站 - 本站为第三方信息聚合平台，非 91.cc 官方网站
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <a href="/about#contact" className="hover:text-primary-400 transition-colors">联系我们</a>
              <span>|</span>
              <span>安全 · 便捷 · 全面</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}